import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { styled } from '@mui/system'

export const NavMenuItemContainer = styled('div')<{
    active?: boolean
    theme?: TTheme
}>`
    transition: all 0.2s linear;
    padding: 8px 20px 8px 14px;
    display: flex;
    gap: 15px;
    align-items: center;
    color: ${({ theme }) => theme?.colors.semantic.sidebarText};
    margin-bottom: 12px;
    border-radius: 4px;
    cursor: pointer;

    ${({ active, theme }) =>
        active &&
        `
        background-color: ${theme?.colors.primary[400]};
        color: ${theme?.colors.greys[0]};
        .extra-icon-container {
            svg {
                color: ${theme?.colors.greys[0]};
            }
        }
    `}

    &:hover {
        background-color: ${({ theme }) => theme?.colors.primary[300]};
        color: ${({ theme }) => theme?.colors.greys[0]};
        .extra-icon-container {
            svg {
                color: ${({ theme }) => theme?.colors.greys[0]};
            }
        }
    }
`

export const LeftContainer = styled('div')`
    display: flex;
    align-items: center;
    gap: 15px;
    color: inherit;
`

export const NavMenuItemText = styled(Typography)<{
    active?: boolean
    theme?: TTheme
}>`
    ${({ active, theme }) =>
        `color: ${active ? theme?.colors.greys[0] : theme?.colors.semantic.sidebarText};
    `}
    color: inherit;
`

export const ExtraIconContainer = styled('div')<{
    boldIcon: boolean
    theme?: TTheme
}>`
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: inherit;
    margin-top: 2px;

    ${({ boldIcon, theme }) =>
        boldIcon &&
        `color: ${theme?.colors.semantic.sideBarActivate};
    `}
`

export const IconContainer = styled('div')<{
    active?: boolean
    theme?: TTheme
}>`
    ${({ active, theme }) =>
        `color: ${active ? theme?.colors.greys[0] : theme?.colors.semantic.sidebarText};
`}
    color: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
`
